import { useEffect, useRef, useState } from "react";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const previewSrc = (remix) =>
  remix.preview_url || (remix.preview_path ? `${API}/remixes/${remix.id}/preview` : "");

let sharedAudio = null;

export const usePreviewPlayer = () => {
  const [playingId, setPlayingId] = useState(null);
  const [progress, setProgress] = useState(0);
  const [loadingId, setLoadingId] = useState(null);
  const audioRef = useRef(null);

  useEffect(() => {
    if (!sharedAudio) sharedAudio = new Audio();
    const audio = sharedAudio;
    audioRef.current = audio;
    const onTime = () => setProgress(audio.duration ? audio.currentTime / audio.duration : 0);
    const onEnd = () => { setPlayingId(null); setProgress(0); };
    const onPlaying = () => setLoadingId(null);
    audio.addEventListener("timeupdate", onTime);
    audio.addEventListener("ended", onEnd);
    audio.addEventListener("playing", onPlaying);
    return () => {
      audio.removeEventListener("timeupdate", onTime);
      audio.removeEventListener("ended", onEnd);
      audio.removeEventListener("playing", onPlaying);
      audio.pause();
    };
  }, []);

  const toggle = async (remix) => {
    const audio = audioRef.current;
    const src = previewSrc(remix);
    if (!audio || !src) return;
    if (playingId === remix.id) {
      audio.pause();
      setPlayingId(null);
      return;
    }
    audio.src = src;
    setProgress(0);
    setLoadingId(remix.id);
    setPlayingId(remix.id);
    try {
      await audio.play();
    } catch {
      setPlayingId(null);
      setLoadingId(null);
    }
  };

  return { playingId, loadingId, progress, toggle };
};
